import React, { ReactNode } from "react";
import { Routes } from "@Libs/Router/Components/Routes/Routes";
import { Route } from "@Libs/Router/Components/Route/Route";
import { ChoosePaymentMethod } from "./ChoosePaymentMethod/ChoosePaymentMethod";
import { ConfigurePayment } from "./ConfigurePayment/ConfigurePayment";
import {
  PaymentMethodType,
  PaymentMethodProviderCombination,
} from "../../types";
import { createFlow } from "@Libs/Flow/services/createFlow";
import { withFlow } from "@Libs/Flow/hocs/withFlow";

export type IPayFlowRoutes = "CHOOSE_PAYMENT_METHOD" | "CONFIGURE_PAYMENT";

export interface PayFlowState {
  allowedPaymentMethods: PaymentMethodType[];
  enabledPaymentMethods: PaymentMethodType[];
  operationSummary?: ReactNode;
  paymentFormMessage?: ReactNode;
  resourceId: string;
  relatedServiceId?: number;
  resourceType: "basket";
}

export const PayFlow = createFlow<
  PaymentMethodProviderCombination<PaymentMethodType> & {
    isPaymentConfirmed: boolean;
  },
  PayFlowState
>({
  root: "PAY",
  state: {
    allowedPaymentMethods: [],
    enabledPaymentMethods: [],
    operationSummary: null,
    resourceId: "",
    resourceType: "basket",
  },
});

export const Pay = withFlow(PayFlow, () => {
  return (
    <Routes>
      <Route fragments="ROOT" element={<ChoosePaymentMethod />} />
      <Route
        fragments="CHOOSE_PAYMENT_METHOD"
        element={<ChoosePaymentMethod />}
      />
      <Route fragments="CONFIGURE_PAYMENT" element={<ConfigurePayment />} />
    </Routes>
  );
});
